import type { TSvgIconProps } from '../icon.component';

const PdsOutlineGiftCard = ({ ...props }: TSvgIconProps) => {
  return (
    <svg
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13 11C12.4477 11 12 11.4477 12 12C12 12.5523 12.4477 13 13 13H16C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11H13Z"
        fill="inherit"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 0C1.79086 0 0 1.79086 0 4V12C0 14.2091 1.79086 16 4 16H16C18.2091 16 20 14.2091 20 12V4C20 1.79086 18.2091 0 16 0H4ZM2 4C2 2.89543 2.89543 2 4 2H6.5V4.38612C5.81694 3.90911 4.88546 3.86263 4.12174 4.31474C3.08512 4.92841 2.67914 6.26955 3.27692 7.33543C3.31055 7.3954 3.34862 7.45016 3.38888 7.5H2V4ZM8 10.0607V14H16C17.1046 14 18 13.1046 18 12V9H9.06066L10.2803 10.2197C10.5732 10.5126 10.5732 10.9874 10.2803 11.2803C9.98744 11.5732 9.51256 11.5732 9.21967 11.2803L8 10.0607ZM6.5 14V10.0607L5.28033 11.2803C4.98744 11.5732 4.51256 11.5732 4.21967 11.2803C3.92678 10.9874 3.92678 10.5126 4.21967 10.2197L5.43934 9H2V12C2 13.1046 2.89543 14 4 14H6.5ZM18 7.5H11.111C11.1513 7.45016 11.1894 7.3954 11.223 7.33543C11.8208 6.26955 11.4148 4.92841 10.3782 4.31474C9.61449 3.86265 8.68306 3.9091 8 4.38607V2H16C17.1046 2 18 2.89543 18 4L18 7.5ZM9.61406 5.60552C9.25212 5.39126 8.84291 5.51996 8.67177 5.82513C8.4577 6.20682 8.26001 6.68306 8.13418 7.24329C8.41046 7.16615 8.69129 7.08247 8.95487 6.99393C9.27115 6.88768 9.53899 6.7821 9.73428 6.68251C9.83173 6.63281 9.8952 6.59258 9.93202 6.56461L9.93502 6.56231C10.0842 6.24656 9.97134 5.81703 9.61406 5.60552ZM4.88587 5.60552C5.24781 5.39126 5.65701 5.51996 5.82816 5.82513C6.04222 6.20682 6.23991 6.68306 6.36575 7.24329C6.08947 7.16615 5.80864 7.08247 5.54506 6.99393C5.22878 6.88768 4.96093 6.7821 4.76565 6.68251C4.6682 6.63281 4.60473 6.59258 4.56791 6.56461L4.5649 6.56231C4.41572 6.24656 4.52858 5.81703 4.88587 5.60552Z"
        fill="inherit"
      />
    </svg>
  );
};
export default PdsOutlineGiftCard;
